import { array, bool, func, number, oneOf, string } from 'prop-types'
import InfiniteList from '../../../InfiniteList'
import Loader from '../../../Loader'
import { kuiperClassNames } from '../../../utils'
import Filter from '../../Filter'

// @note `item` must always be the final parameter because of how this function
//   is called.
const renderItem = (
  onFilterSelect,
  onFilterRemove,
  highlightedFilterId,
  onFilterMouseMove,
  value,
  theme,
  item
) => {
  const selected = Boolean(value && value.includes(item.id))
  const clickHandler = selected
    ? onFilterRemove.bind(this, item.id)
    : onFilterSelect.bind(this, { id: item.id, disabled: false })
  return (
    <Filter
      highlighted={item.id === highlightedFilterId}
      isAddable={!selected}
      isRemovable={selected}
      key={item.id}
      onClick={clickHandler}
      onMouseMove={onFilterMouseMove}
      selected={selected}
      theme={theme}
      {...item}
    />
  )
}

const FilterResults = ({
  highlightedFilterId,
  loading,
  onFilterMouseMove,
  onFilterRemove,
  onFilterSelect,
  results,
  scrollToIndex,
  theme = 'light',
  value,
}) => (
  <div className={kuiperClassNames('filter-browser')}>
    <InfiniteList marginBottom={4} rowHeight={26} scrollToIndex={scrollToIndex}>
      {loading ? (
        <Loader minHeight={26} theme="transparent" />
      ) : (
        results.map(
          renderItem.bind(
            this,
            onFilterSelect,
            onFilterRemove,
            highlightedFilterId,
            onFilterMouseMove,
            value,
            theme
          )
        )
      )}
    </InfiniteList>
  </div>
)
FilterResults.displayName = 'Kuiper: FilterResults ← SearchResults ← FilterBar '

FilterResults.propTypes = {
  highlightedFilterId: string,
  loading: bool,
  onFilterMouseMove: func,
  onFilterRemove: func,
  onFilterSelect: func,
  results: array,
  scrollToIndex: number,
  theme: oneOf(['dark', 'light']),
  value: array,
}

export default FilterResults
